function setData(state, data) {
    const { transaction_group_history } = data;
    if (transaction_group_history) {
        return { ...state, ...transaction_group_history };
    }
    return state;
}

export default (state = {}, action = {}) => {
    const { type, payload = {} } = action;
    switch (type) {
        default:
            return setData(state, payload);
    }
};
